import React from "react";

// Material UI
import Avatar from "@material-ui/core/Avatar";

// Locals
import DataRow from "./dataRow";
import { firestoreTimestampToFormatted } from "../../helpers/format";
import { useCurrentWsDateFormat, useData } from "../../firebase";
import { firestoreQuery } from "../../constants";

// Types
import type { WorkspaceUser } from "../../users/types";

// Styles
import useStyles from "../styles";

interface Props {
  user: WorkspaceUser;
}

interface InfoPanelProps {
  user?: WorkspaceUser;
}

const AvatarPanel: React.FC<Props> = ({ user }) => {
  const classes = useStyles();

  return (
    <div className={classes.avatarPanel}>
      <Avatar
        data-cy={"user-avatar"}
        className={classes.avatar}
        src={user?.photoURL || undefined}
      />
      <div className={classes.avatarText}>
        <div className={classes.avatarName}>{user?.displayName || user?.name}</div>
        <div className={classes.avatarEmail}>{user?.email}</div>
      </div>
    </div>
  );
};

const InfoPanel: React.FC<InfoPanelProps> = ({ user }) => {
  const classes = useStyles();
  const dateFormat = useCurrentWsDateFormat();
  // used for converting userId (createdBy) into name
  const wsUsers = useData<WorkspaceUser>(firestoreQuery.wsUsers);
  const addedBy = user?.createdBy && wsUsers ? wsUsers[user.createdBy]?.displayName : "";

  // converts seconds into date
  const addedAt = firestoreTimestampToFormatted(user?.createdAt, dateFormat);

  return (
    <table className={classes.bigMarginRight}>
      <tbody>
        <DataRow dataCy={"userinfo-name"} title="Name" value={user?.name || ""} />
        <DataRow dataCy={"userinfo-email"} title="Email" value={user?.email || ""} />
        <DataRow dataCy={"userinfo-added"} title="Added" value={addedAt} />
        <DataRow dataCy={"userinfo-addedby"} title="Added by" value={addedBy} />
      </tbody>
    </table>
  );
};

const LeftPanel: React.FC<Props> = ({ user }) => {
  const classes = useStyles();

  return (
    <div className={classes.leftPanelWrapper}>
      <AvatarPanel user={user} />
      <InfoPanel user={user} />
    </div>
  );
};

export default LeftPanel;
